const ossApi = '/ossApi'
let hostname = window.location.hostname
const encryptionJS = require('../../assets/js/encryption');
let tenantCode = ''
let title = ''
let imageUrl = ''
let username = ''
let password = ''
let serviceUrl = ''  //履职服务平台
console.log(hostname)
if (hostname === 'www.yjxrd.gov.cn' || hostname === 'yjxrd.gov.cn') {
  tenantCode = '410726000000000001'
  title = '延津'
  imageUrl = ossApi + '/410726'
  username = encryptionJS.aesDecrypt('/oLJWoGYvqtnXXiDyzvJJw==')
  password = encryptionJS.aesDecrypt('1ZtiUWfxB0SF8Sj8di81+g==')
  serviceUrl = 'http://39.98.66.183:9000/yjrd'
} else if (hostname === 'www.yuanyangrd.gov.cn' || hostname === 'yuanyangrd.gov.cn') {
  tenantCode = '410725000000000001'
  title = '原阳'
  imageUrl = ossApi + '/410725'
  username = encryptionJS.aesDecrypt('9UeLtESF3rY/dRSdGGttrg==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
  serviceUrl = 'http://39.98.66.183:9000/yyxrd'
} else if (hostname === 'www.fengqiurenda.gov.cn' || hostname === 'fengqiurenda.gov.cn') {
  tenantCode = '410727000000000001'
  title = '封丘'
  imageUrl = ossApi + '/410727'
  username = encryptionJS.aesDecrypt('pIIJ30Nsitml8ebOyDg9IA==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
  serviceUrl = 'http://39.98.66.183:9000/fqxrd'
}



switch (process.env.NODE_ENV) {
  case 'development': // 开发环境
    tenantCode = '410726000000000001'
    title = '延津'
    imageUrl = ossApi + '/410726'
    username = encryptionJS.aesDecrypt('/oLJWoGYvqtnXXiDyzvJJw==')
    password = encryptionJS.aesDecrypt('1ZtiUWfxB0SF8Sj8di81+g==')
    serviceUrl = 'http://39.98.66.183:9000/yjrd'
    break
  default:
    break
}
export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  serviceUrl
}
